import React from 'react';

export default function PayloadMessage(props) {

    return (
        <><span key={0}>{props.message.button.text} </span> <i>{props.message.button.payload}</i></>
    )
}